<template>
  <div id="init-content">
    <div class="text-center">{{msg}}</div>
    <div style="padding-top:30px;" class="text-center" v-if="errShow">
      <button type="button" class="btn btn-warning btn-lg" @click="quit()" @touchstart="quit()">退出应用</button>
    </div>
  </div>
</template>

<script>
import * as deviceOperate from "../assets/js/deviceOperate";
import * as jssFunction from "../assets/js/jssFunction";
export default {
  data() {
    return {
      msg: "系统正在初始化...",
      errShow: false
    };
  },
  mounted: function() {
    this.init();
  },

  methods: {
    init: function() {
      let devSn="";
      try {
        if (global.LOCAL_DATA.devInfo.debug) {
          global.LOCAL_DATA.devInfo.devSn = "TL_MY_01";
        } else {
           devSn = jssFunction.getQueryString("v");
          if (
            devSn == "TL_MY_2" ||
            devSn == "TL_JQ_2" ||
            devSn == "TL_CY_2" ||
            devSn == "TL_MY_01"
          ) {
            global.LOCAL_DATA.devInfo.devSn = devSn;
          } else {
            global.LOCAL_DATA.devInfo.devSn = deviceOperate.getDev().GetHDSN();
          }
        }
      } catch (e) {
        this.msg = "售票客户端尚未安装或安装失败";
        return;
      }


      //   let devSn = "TL_JQ_22";
      let that = this;
      let reqData = {};
      reqData.dev_sn = devSn;
      this.$http
        .post(
          this.GlobalConfig.APP_CONFIG.API_HOST + "init",
          JSON.stringify(reqData),
          this.GlobalConfig.APP_CONFIG.HEADERS
        )
        .then(function(response) {
          if (response.data.status == "success") {
            let url = response.data.devInfo.version_url;
            if (
              devSn == "TL_MY_2" ||
              devSn == "TL_JQ_2" ||
              devSn == "TL_CY_2" ||
              devSn == "TL_MY_01"
            ) {
              url = response.data.devInfo.version_url + "?v=" + devSn;
            }

            window.location.href = url;
          } else {
            that.msg = response.data.msg;
            that.errShow = true;
          }
        })
        .catch(() => {
          that.msg = "网络异常，请退出检查终端机是否已经联网";
          that.errShow = true;
          setTimeout(() => {
            that.init();
          }, 20000);
        });
    },
    //退出系统
    quit: function() {
      if (jssFunction.androidClick()) return;
      deviceOperate.getDev().SystemCtrl(10);
    }
  }
};
</script>


<style scoped>
#init-content {
  height: 1920px;
  padding-top: 20%;
  font-size: 60px;
  font-weight: bolder;
  color: wheat;
  overflow: hidden;
  background-image: url("../../static/image/bg/bg03.jpg");
}
</style>




// WEBPACK FOOTER //
// src/views/init.vue